import { render, staticRenderFns } from "./use.vue?vue&type=template&id=67b12dd8&scoped=true&"
import script from "./use.vue?vue&type=script&setup=true&lang=ts&"
export * from "./use.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./use.vue?vue&type=style&index=0&id=67b12dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b12dd8",
  null
  
)

export default component.exports